import * as React from 'react';
import { observer } from 'mobx-react';

import { IBasicTableColumn } from 'ui-lib';
import { IDeviceTableProps } from './components';
import { DeviceSCRFileListingStore } from '../../../../../store/device-details/device-scr-file-listing-store';
import { DeviceReportTable } from './device-report-table';
import { useDeviceStore } from 'store';

export const DeviceSCRFileListingTable = observer((options: IDeviceTableProps) => {
    const devicesStore = useDeviceStore();
    const memoizedStore = React.useMemo(() => {
        const scrFileListingStore = new DeviceSCRFileListingStore({
            accountId: options.accountId,
            uid: options.uid,
            devicesStore: devicesStore,
            serialNumber: options.serialNumber,
        });
        scrFileListingStore.initialize();
        return scrFileListingStore;
    }, []);

    const columns: IBasicTableColumn[] = [
        { code: 'name', title: 'File Name', dataIndex: 'name' },
        { code: 'updateCount', title: 'Update Count', dataIndex: 'updateCount' },
        { code: 'crc', title: 'CRC', dataIndex: 'crc' },
    ];

    return <DeviceReportTable store={memoizedStore} table={{ columns, dataSource: memoizedStore.displaySCRFiles }} />;
});
